import { store } from '@/state/store';
import { logw } from '@shared/utils/utils_logs';

export class UTILS__html {}

export const string_to_span = (value: string): React.ReactElement | null => {
  if (!value) return null;

  value = value.replace(/\n/g, '<br/>');

  return (
    <span
      style={{
        whiteSpace: 'pre-wrap',
        tabSize: 4, // Controls how many "spaces" wide the tab character is
      }}
      dangerouslySetInnerHTML={{ __html: value }}
    />
  );
};

//mobile + desktop
export const md = (classes_mobile: string, classes_desktop: string) => {
  return mtd(classes_mobile, '', classes_desktop);
};

//mobile + tablet + desktop
export const mtd = (classes_mobile: string, classes_tablet: string, classes_desktop: string) => {
  if ((classes_mobile + classes_tablet + classes_desktop).trim().length === 0) logw('delete this call because it is empty');

  const { global_is_desktop, global_is_mobile, global_is_tablet } = store.getState().slice_ui;

  let out = '';

  if (global_is_desktop) {
    out = classes_desktop;
  } else if (global_is_mobile) {
    out = classes_mobile;
  } else if (global_is_tablet) {
    out = classes_tablet;
  }

  return out;
};
